import Vue from 'vue'
import VueI18n from 'vue-i18n'
import App from './App.vue'
import router from './router'
import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles
import '@/assets/css/base.scss'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 引入各个语言配置文件
import zh from './language/zh';
import en from './language/en';
import es from './language/es';
import VueTouch from 'vue-touch';
Vue.use(VueTouch, { name: 'v-touch' });

Vue.config.productionTip = false;
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || 'zh', // 语言标识
  //this.$i18n.locale // 通过切换locale的值来实现语言切换
  messages: {
    en: en, // 英文
    zh: zh, // 中文
    es: es, // 西班牙语
  }
});
ElementUI.i18n((key, value) => i18n.t(key, value));
Vue.use(ElementUI);
export default i18n;
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  ak: 'D4cxhpDLAmKTeI9tTCBSX730k3SbpmFn'
})
// 引入多语言字段辅助工具
import { i18nFieldMixin } from './utils/i18nHelper';
Vue.mixin(i18nFieldMixin);

function isImageElement(element) {
  return element instanceof Element && element.tagName === 'IMG';
}

function hasBackgroundImage(element) {
  if (!(element instanceof Element)) {
    return false;
  }

  let current = element;

  while (current && current !== document.documentElement) {
    if (window.getComputedStyle(current).backgroundImage.indexOf('url(') !== -1) {
      return true;
    }

    current = current.parentElement;
  }

  return false;
}

document.addEventListener('contextmenu', function (event) {
  const target = event.target;

  if (isImageElement(target) || hasBackgroundImage(target)) {
    event.preventDefault();
  }
}, true);

document.addEventListener('dragstart', function (event) {
  if (isImageElement(event.target)) {
    event.preventDefault();
  }
}, true);


AOS.init();
new Vue({
  i18n, // 国际化挂载
  el: '#app',
  router,
  render: h => h(App)
})
